module.exports = __webpack_public_path__ + "static/media/tap_image@2x.4ae02b70.png";